import { Routes, Route } from "react-router-dom";
import ListOoraPlans from "../Components/Oora/ooraPlanList";
const OoraPlanRoutes= () => {
  return (
    <Routes>
      <Route path="/oora" element={<ListOoraPlans/>}></Route>
    </Routes>
  );
};

export default OoraPlanRoutes

